import React from "react";
import GenericForm from "./GenericForm";
import StringInput from "../formElements/StringInput";
import SelectInput from "../formElements/SelectInput";

function ProductForm(props) {
    const formContent = (data, update) => (
        <>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Produktová skupina"
                     labelNew="Pridať skupinu"
                     baseUrl='/product/product_groups/'
                     formContent={formContent}/>
    )
}

export default ProductForm
